import React from 'react'
import Box from '../../atoms/box/box'
import AverageRating from '../../molecules/average-rating/average-rating'
import QualifyBox from '../../molecules/qualify-box/qualify-box'
import starYellow from '../../../assets/images/estrella_amarilla.png'
import starGray from '../../../assets/images/estrella_gris.png'
import './qualify-section-content.scss'

const QualifySectionContent = props => {
	const { itemsRateDetails, ratingDetail } = props
	const filledStars = Math.floor(ratingDetail?.productAvg)

	const handleRenderStars = () => {
		const starsArray = []
		for (let i = 0; i < 5; i++) {
			if (i < filledStars) {
				starsArray.push(<img key={i} className='f-box-star' src={starYellow} />)
			} else {
				starsArray.push(<img key={i} className='f-box-star' src={starGray} />)
			}
		}
		return starsArray
	}

	return (
		<section className='f-qualify-section'>
			<QualifyBox
				title='Calificación'
				isTitleVisible={!props.isMobile}
				child={
					<Box
						child={
							<div className='f-box-wrapper'>
								<label className='f-box-qualify'>
									{ratingDetail?.productAvg?.toFixed(1)} / 5
								</label>
								<div className='f-box-star-container'>
									{handleRenderStars()}
								</div>
								<small className='f-box-opinions'>
									{ratingDetail?.totalQualifications} opiniones
								</small>
							</div>
						}
					/>
				}
			/>
			<QualifyBox
				title='Detalles'
				child={
					<>
						{itemsRateDetails &&
							itemsRateDetails.map((average, index) => {
								const totalVotes = itemsRateDetails.reduce((a, b) => ({
									numberVotes: a.numberVotes + b.numberVotes,
								}))?.numberVotes
								const porcentaje = (average.numberVotes / totalVotes) * 100

								return (
									<AverageRating
										key={index}
										starNumber={average?.qualification}
										progress={porcentaje}
										votesFrom={average?.numberVotes}
										votesTo={totalVotes}
									/>
								)
							})}
					</>
				}
			/>
			<QualifyBox
				title={props.isMobile ? 'Calificación' : 'Items calificados'}
				child={
					<Box
						child={
							<div className='f-box-wrapper-items'>
								{ratingDetail &&
									ratingDetail?.productAvgGroupByCategory.map(
										(qualification, index) => (
											<div
												className='f-box-wrapper-items-qualification'
												key={index}
											>
												<small>{qualification.categoryName}</small>
												<div>
													<label>{qualification.avgQualification}</label>
													<img src={starYellow} />
												</div>
											</div>
										)
									)}
							</div>
						}
					/>
				}
			/>
		</section>
	)
}

export default QualifySectionContent
